<template>
  <custom-dialog appendToBody width="700px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form :model="form" :rules="rules" :validate-on-rule-change="false" ref="form">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('department_item_dialog.shang_ji_bu_men')">
              <el-input v-model="form.parentName" placeholder="" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('Common.com_department_name')" prop="departmentName">
              <el-input v-model="form.departmentName" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('department_item_dialog.bu_men_jian_cheng')" prop="departmentShort">
              <el-input v-model="form.departmentShort" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('department_item_dialog.lian_xi_ren')" prop="contactName">
              <el-input v-model="form.contactName" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('department_item_dialog.lian_xi_dian_hua')" prop="contactPhone">
              <el-input v-model="form.contactPhone" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('department_item_dialog.bu_men_miao_shu')" prop="departmentDesc">
              <el-input v-model="form.departmentDesc" placeholder=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="warning" @click="saveOrgan">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>
<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        parentId: '',
        parentName: '',
        departmentId: '',
        departmentName: '',
        departmentPath: '',
        departmentShort: '',
        departmentDesc: '',
        contactName: '',
        contactPhone: '',
        showOrder: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        departmentName: [
          {
            type: 'string',
            required: true,
            message: this.$t('department_item_dialog.bmmcbt'),
          },
          {
            type: 'string',
            max: 40,
            message: this.$t('department_item_dialog.bncg40gzf'),
          },
        ],
        departmentShort: [
          {
            type: 'string',
            required: true,
            message: this.$t('department_item_dialog.bmjcbt'),
          },
          {
            max: 20,
            type: 'string',
            message: this.$t('department_item_dialog.bncg20gzf'),
          },
        ],
        departmentDesc: {
          max: 100,
          type: 'string',
          message: this.$t('department_item_dialog.bncg100gzf'),
        },
      };
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    initDialog: function () {
      if (this.model.type === 'add') {
        this.form.parentId = this.model.bizId;
        this.form.parentName = this.model.bizName;
      }
      if (this.model.type === 'edit') {
        this.getParentOrgan();
      }
    },
    // 获取部门信息
    getParentOrgan: function () {
      this.$getJSON(`${apis.Department}/${this.model.bizId}`).then((res) => {
        const parentData = res.data;
        this.$setFormatData(this.form, parentData);
      });
    },
    // 确认保存用户
    saveOrgan: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'add') {
          this.saveAddOrgan();
        }
        if (this.model.type === 'edit') {
          this.saveEditOrgan();
        }
      });
    },
    // 保存新增用户
    saveAddOrgan: function () {
      this.$postJSON(apis.DepartmentAdd, this.form, true).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.visible = false;
        this.$emit('success');
      });
    },
    // 保存编辑用户
    saveEditOrgan: function () {
      this.$postJSON(apis.DepartmentUpdate, this.form, true).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.visible = false;
        this.$emit('success');
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
</style>
